export const defaultHeaders = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
import RSAA from "redux-api-middleware/es/RSAA";

// =====================================================================================================================

// Action Names

export const types = {
    ACTION_LIST: 'LOAD',
    ACTION_SELECT: 'SELECT',
    ACTION_CREATE: 'CREATE',
    ACTION_UPDATE: 'UPDATE',
    ACTION_DESTROY: 'DESTROY',
    ACTION_INVALIDATE: 'INVALIDATE'
};

// Helpers

export const actions = {
    resourceAction: (modelName, actionName) => {
        return `${modelName}_${actionName}`;
    },

    resourceActionSuccess: (modelName, actionName) => {
        return `${actions.resourceAction(modelName, actionName)}_SUCCESS`;
    },

    resourceActionError: (modelName, actionName) => {
        return `${actions.resourceAction(modelName, actionName)}_ERROR`
    },

    resourcesAction: (modelName, actionName) => {
        return `${modelName}S_${actionName}`;
    },

    resourcesActionSuccess: (modelName, actionName) => {
        return `${actions.resourcesAction(modelName, actionName)}_SUCCESS`;
    },

    resourcesActionError: (modelName, actionName) => {
        return `${actions.resourcesAction(modelName, actionName)}_ERROR`
    },

    invalidateResources: (modelName) => {
        return {type: actions.resourcesAction(modelName, ACTION_INVALIDATE)}
    }
};

export function handleApiResponse(modelName, actionName, promise, onSuccess, onInvalid, onError) {
    return promise.then((result) => {
        if (result.type === actions.resourceActionSuccess(modelName, actionName)) {
            onSuccess(result);
        } else {
            if (result.payload.status === 422 && result.payload.response) {
                onInvalid(result);
            } else {
                onError(result);
            }
        }
    }).catch((error) => {
        onError(error);
    });
};

export function listResources(namespace, modelName, filter, store = true) {
    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/${namespace}/${modelName.toLowerCase()}s/index`,
            method: 'POST',
            headers: defaultHeaders,
            types: [
                { type: actions.resourcesAction(modelName, `${types.ACTION_LIST}${store ? '' : '_TMP'}`), meta: { filter: filter }},
                { type: actions.resourcesActionSuccess(modelName, `${types.ACTION_LIST}${store ? '' : '_TMP'}`), meta: { filter: filter }},
                { type: actions.resourcesActionError(modelName, `${types.ACTION_LIST}${store ? '' : '_TMP'}`), meta: { filter: filter }}
            ],
            credentials: 'same-origin',
            body: JSON.stringify(filter)
        },
        auth: true
    };
}

function shouldListResources(namespace, modelName, state, filter) {
    const resources = state[`${modelName.toLowerCase()}s`];

    if (JSON.stringify(resources.filter) !== JSON.stringify(filter)) {
        return true;
    }

    if (!resources.list) {
        return true
    } else if (resources.loading) {
        return false
    } else {
        return resources.loadingInvalid;
    }
}

export function listResourcesIfNeeded(namespace, modelName, filter = {}) {
    return (dispatch, getState) => {
        if (shouldListResources(namespace, modelName, getState(), filter)) {
            return dispatch(listResources(namespace, modelName, filter))
        }
    }
}

export function invalidateResources(modelName) {
    return { type: actions.resourcesAction(modelName, types.ACTION_INVALIDATE) }
}

export function selectResource(namespace, modelName, params, store = true) {
    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/${namespace}/${modelName.toLowerCase()}s/${params.id}`,
            method: 'POST',
            headers: defaultHeaders,
            types: [
                actions.resourceAction(modelName, `${types.ACTION_SELECT}${store ? '' : '_TMP'}`),
                actions.resourceActionSuccess(modelName, `${types.ACTION_SELECT}${store ? '' : '_TMP'}`),
                actions.resourceActionError(modelName, `${types.ACTION_SELECT}${store ? '' : '_TMP'}`)
            ],
            credentials: 'same-origin'
        },
        auth: true
    };
}


export function createResource(namespace, modelName, params) {
    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/${namespace}/${modelName.toLowerCase()}s`,
            method: 'POST',
            body: JSON.stringify({resource: params.resource}),
            headers: defaultHeaders,
            types: [
                actions.resourceAction(modelName, types.ACTION_CREATE),
                actions.resourceActionSuccess(modelName, types.ACTION_CREATE),
                actions.resourceActionError(modelName, types.ACTION_CREATE)
            ],
            credentials: 'same-origin'
        },
        auth: true
    };
}

export function updateResource(namespace, modelName, params) {
    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/${namespace}/${modelName.toLowerCase()}s/${params.id}`,
            method: 'PATCH',
            headers: defaultHeaders,
            body: JSON.stringify({ resource: params.resource }),
            types: [
                { type: actions.resourceAction(modelName, types.ACTION_UPDATE), meta: { id: params.id } },
                { type: actions.resourceActionSuccess(modelName, types.ACTION_UPDATE), meta: { id: params.id  } },
                { type: actions.resourceActionError(modelName, types.ACTION_UPDATE), meta: { id: params.id  } }
            ],
            credentials: 'same-origin'
        },
        auth: true
    };
}

export function destroyResource(namespace, modelName, params) {
    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/${namespace}/${modelName.toLowerCase()}s/${params.id}`,
            method: 'DELETE',
            headers: defaultHeaders,
            types: [
                { type: actions.resourceAction(modelName, types.ACTION_DESTROY), meta: { id: params.id } },
                { type: actions.resourceActionSuccess(modelName, types.ACTION_DESTROY), meta: { id: params.id } },
                { type: actions.resourceActionError(modelName, types.ACTION_DESTROY), meta: { id: params.id } }
            ],
            credentials: 'same-origin'
        },
        auth: true
    };
}

// export function actionPromise(namespace, modelName, actionName, action, params, onSuccess = (response) => {}, onValidationError = (response) => {}, onError = (error) => {}) {
//     return new Promise((resolve, reject) => {
//         action(namespace, modelName, params).then((result) => {
//             if (result.type === actions.resourceActionSuccess(modelName, actionName)) {
//                 onSuccess(result.payload);
//                 resolve();
//             } else {
//                 if (result.payload.status === 422 && result.payload.response) {
//                     onValidationError(result.payload.response);
//                     // reject(result.payload.response.errors);
//                     reject({test: ['ss'], te: 'ss', a: { b: ['ss'] }});
//                 } else {
//                     onError(result);
//                     reject({});
//                 }
//             }
//         }).catch(onError);
//     });
// }
